import PropTypes from 'prop-types';
import React, { Component } from 'react';
import 'react-dates/initialize';
import momentPropTypes from 'react-moment-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ButtonTabs from '../../../../core/modules/common/components/ButtonTabs';
import DatePickerConstants from '../../../common/config/DatePickerConstants';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
// import ProgressButtons from '../../common/components/ProgressButtons';
import { enteredWizard } from '../../common/redux/actions/SelectionCriteriaWizardActions';
import DateFieldSelector from '../components/DateFieldSelector';
import DayPicker from '../components/DayPicker';
import MonthPicker from '../components/MonthPicker';
import PeriodDisplay from '../components/PeriodDisplay';
import WeekPicker from '../components/WeekPicker';
import {
  dateFieldSelected,
  datePickerSelected,
  dayPeriodSelected,
  monthPeriodSelected,
  weekPeriodSelected,
} from '../redux/actions/PeriodSelectionActions';
import {
  getDateField,
  getDayPickerDates,
  getMonthPickerDates,
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
  getSelectedDatePicker,
  getWeekPickerDates,
  getPeriodSelectorPredefinedRange,
} from '../redux/selectors/PeriodSelectionSelectors';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import ProgressButtons from '../../common/components/ProgressButtons';

const SC_CODE = sc.SC001_02_03;

// eslint-disable-next-line react/prefer-stateless-function
class PeriodSelectionWizardContainer extends Component {
  render() {
    const dayPeriodStartDate = new Date(this.props.startDate);
    const dayPeriodEndDate = new Date(this.props.endDate);
    const reportId = this.props.match.params.reportName;
    const {
      periodSelection: {
        availablePickers, maxRange, availableDateTypes, defaultDateType,
      },
    } = ReportDefinitions[reportId];
    const selectionCriteria = ReportDefinitions[reportId].selectionCriteria.items;
    const selectedDateTypeExists = (availableDateTypes || []).indexOf(this.props.dateField) > -1;
    const selectedDateType = selectedDateTypeExists ? this.props.dateField : defaultDateType;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;

    return (
      <div className="period-selection-wrapper">
        <div className="period-selection">
          <PeriodDisplay
            startDate={this.props.startDate}
            endDate={this.props.endDate}
          />
          <div className="period-selection-content">
            <div className="date-picker">
              <ButtonTabs
                tabs={availablePickers}
                activeTab={this.props.selectedDatePicker}
                onChange={this.props.datePickerSelected}
              />
              {this.props.selectedDatePicker === DatePickerConstants.DAY.value &&
              <DayPicker
                onPeriodSelected={this.props.dayPeriodSelected}
                startDate={dayPeriodStartDate}
                endDate={dayPeriodEndDate}
                maxRange={maxRange.dayPicker}
                predefinedRange={this.props.predefinedRange}
              />}
              {this.props.selectedDatePicker === DatePickerConstants.WEEK.value &&
              <WeekPicker
                onPeriodSelected={this.props.weekPeriodSelected}
                startDate={this.props.weekPicker.startDate}
                endDate={this.props.weekPicker.endDate}
                maxRange={maxRange.weekPicker}
                predefinedRange={this.props.predefinedRange}
              />}
              {this.props.selectedDatePicker === DatePickerConstants.MONTH.value &&
              <MonthPicker
                onPeriodSelected={this.props.monthPeriodSelected}
                startDate={this.props.monthPicker.startDate}
                endDate={this.props.monthPicker.endDate}
                maxRange={maxRange.monthPicker}
                predefinedRange={this.props.predefinedRange}
              />}
            </div>

            <div className="sidebar">
              <DateFieldSelector
                onChange={this.props.dateFieldSelected}
                dateTypes={availableDateTypes}
                selectedDateType={selectedDateType}
              />
            </div>
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
  selectedDatePicker: getSelectedDatePicker(state),
  predefinedRange: getPeriodSelectorPredefinedRange(state),
  weekPicker: getWeekPickerDates(state),
  monthPicker: getMonthPickerDates(state),
  dayPicker: getDayPickerDates(state),
  dateField: getDateField(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  dateFieldSelected,
  enteredWizard,
  datePickerSelected,
  weekPeriodSelected,
  monthPeriodSelected,
  dayPeriodSelected,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PeriodSelectionWizardContainer);

PeriodSelectionWizardContainer.propTypes = {
  /* eslint-disable react/no-typos */
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
  // eslint-disable-next-line react/no-unused-prop-types
  enteredWizard: PropTypes.func,
  dateFieldSelected: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  location: PropTypes.shape({
    query: PropTypes.shape({
      first: PropTypes.string,
    }),
  }),
  datePickerSelected: PropTypes.func,
  selectedDatePicker: PropTypes.string,
  predefinedRange: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  dayPicker: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  weekPicker: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  monthPicker: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  weekPeriodSelected: PropTypes.func,
  monthPeriodSelected: PropTypes.func,
  dayPeriodSelected: PropTypes.func,
  dateField: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  routes: PropTypes.objectOf(PropTypes.shape),
  // eslint-disable-next-line react/no-unused-prop-types
  match: PropTypes.shape({
    params: PropTypes.shape({
      reportName: PropTypes.string,
    }),
  }),
};
